import { axiosClient } from '../api/axiosClient';
import {
  ApiPrompt,
  ApiPromptGroup,
  Prompt,
  PromptGroup,
} from '../interfaces/promptLibrary';

const mapApiPromptToPrompt = (apiPrompt: ApiPrompt): Prompt => ({
  id: apiPrompt.id,
  key: apiPrompt.id,
  label: apiPrompt.name,
  value: apiPrompt.description,
  isSystem: apiPrompt.is_system,
  cirraUserId: apiPrompt.cirra_user_id,
  comingSoon: apiPrompt.coming_soon,
  promptGroupId: apiPrompt.group_id,
});

const mapApiGroupToPromptGroup = (apiGroup: ApiPromptGroup): PromptGroup => ({
  id: apiGroup.id,
  key: apiGroup.id,
  label: apiGroup.name,
  type: 'group',
  isSystem: apiGroup.is_system,
  cirraUserId: apiGroup.cirra_user_id,
  children: apiGroup.prompts.map(mapApiPromptToPrompt),
});

// Get all prompts and groups
export const getPromptLibrary = async (
  scope: string[] = ['system', 'my', 'others']
) => {
  const params = new URLSearchParams();
  scope.forEach((s) => params.append('scope[]', s));
  const response = await axiosClient.get<ApiPromptGroup[]>(
    `/prompt-library?${params.toString()}`
  );
  return response.data.map(mapApiGroupToPromptGroup);
};

// Create a new prompt group
export const createPromptGroup = async (data: { label: string }) => {
  await axiosClient.post('/prompt-library/groups', {
    name: data.label,
  });
};

// Update a prompt group
export const updatePromptGroup = async (
  groupId: string,
  data: { label?: string }
) => {
  await axiosClient.patch<ApiPromptGroup>(`/prompt-library/groups/${groupId}`, {
    name: data.label,
  });
};

// Delete a prompt group
export const deletePromptGroup = async (groupId: string) => {
  await axiosClient.delete(`/prompt-library/groups/${groupId}`);
};

// Create a new prompt
export const createPrompt = async (data: {
  label: string;
  value: string;
  promptGroupId: string;
}) => {
  const response = await axiosClient.post<ApiPrompt>(
    '/prompt-library/prompts',
    {
      name: data.label,
      description: data.value,
      group_id: data.promptGroupId,
    }
  );
  return mapApiPromptToPrompt(response.data);
};

// Update a prompt
export const updatePrompt = async (
  promptId: string,
  data: { label?: string; value?: string }
) => {
  const response = await axiosClient.patch<ApiPrompt>(
    `/prompt-library/prompts/${promptId}`,
    {
      name: data.label,
      description: data.value,
    }
  );
  return mapApiPromptToPrompt(response.data);
};

// Delete a prompt
export const deletePrompt = async (promptId: string) => {
  await axiosClient.delete(`/prompt-library/prompts/${promptId}`);
};
